import { render, staticRenderFns } from "./o_pokupka_tovar.vue?vue&type=template&id=def44042&scoped=true&"
import script from "./o_pokupka_tovar.vue?vue&type=script&lang=js&"
export * from "./o_pokupka_tovar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def44042",
  null
  
)

export default component.exports